<template>
  <div id="app">
    <v-app light id="topel">
      
      <v-container v-if="step1" style="padding-bottom:0px;" class="topel">

        <v-layout ma-2>
          <v-flex>
            <v-card>
              <v-toolbar color="primary" dark>
                <v-toolbar-title> <v-chip color="blue darken-3" text-color="white">1</v-chip> Vos informations</v-toolbar-title>
              </v-toolbar>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex sm4 px-3>
            <v-subheader>Votre poids *</v-subheader>
            <v-text-field @blur="checkS1()" suffix="Kg" label="Votre poids" name="poids" prepend-icon="perm_identity" v-model="poids"></v-text-field>
          </v-flex>
          <v-flex sm4 px-3>
            <v-subheader>Votre sexe *</v-subheader>
            <v-radio-group v-model="sexe" @change="checkS1()">
              <v-radio label="Homme" value="H"></v-radio>
              <v-radio label="Femme" value="F"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex sm4 px-3>
            <v-subheader>Avez-vous consommé un repas? *</v-subheader>
            <v-radio-group v-model="repas" @change="checkS1()">
              <v-radio label="OUI" value="Y"></v-radio>
              <v-radio label="NON" value="N"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

      </v-container>

      <v-container v-if="step2" style="padding-top:0px;">

          <v-layout ma-2>
            <v-flex>
              <v-card>
                <v-toolbar color="primary" dark>
                  <v-toolbar-title> <v-chip color="blue darken-3" text-color="white">2</v-chip> Votre consommation</v-toolbar-title>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>

          <v-flex xs12 pa-2 subheading>
            Pour chaque verre consommé, sélectionnez ci-dessous l'heure et ajoutez ensuite la consommation désirée avec le bouton. Vous pouvez ajuster (pour chaque verre), la contenance et la concentration en alcool.
          </v-flex>

            <v-layout row wrap>

              <v-flex auto xs12 sm6 pa-2>
                <v-date-picker v-model="date"  class="mx-auto"
                    locale="fr-FR" 
                    @input="dateFr = formatDate($event)"
                    scrollable
                    first-day-of-week="1"></v-date-picker>
              </v-flex>

              <v-flex auto xs12 sm6 pa-2>
                <v-time-picker v-model="time"  class="mx-auto"
                      format="24hr" 
                      :allowed-hours="allowedTimes.hours"
                      :allowed-minutes="allowedTimes.minutes" 
                      ></v-time-picker>
              </v-flex>

            </v-layout>  
                  
          <v-layout row wrap hidden-xs-only>
            
            <v-flex v-for="(item, index) in boissonsitems" :key="item.id" xs12 sm6 md6 lg4 pa-2>
              <v-card raised hover style="padding:1em 1em 0 0;">    
                <v-layout >
                  <v-flex>
                    <v-subheader class="title"> <v-avatar><img :src="item.avatar" alt=""></v-avatar> {{ item.nom }}</v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout >
                  <v-flex px-2 mx-2 style="max-width:200px;">
                    <v-text-field auto-grow type="number" v-model="item.qte" label="Quantité" suffix="cl" prepend-icon="local_drink"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout >
                  <v-flex px-2 mx-2 style="max-width:200px;">
                    <v-text-field v-model="item.alc" auto-grow type="number" label="Taux d'Alcool" suffix="°" prepend-icon="opacity"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-card-actions>
                  <v-btn flat color="orange" @click="addConso(item.nom, item.qte, item.alc)">Ajouter</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

          </v-layout>

          <v-layout row wrap pa-2 hidden-sm-and-up>
            <v-flex xs12>
              <v-card hover raised>
                <v-layout>
                  <v-flex xs12 px-3>
                    <v-select :items="boissonsitems" label="Choisir la consommation" single-line
                    item-value="id" item-text="nom" v-model="selectboisson"
                    hint="Choisir la boisson" persistent-hint></v-select>    
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-subheader class="title"> <v-avatar><img :src="curSelectBoisson.avatar" alt=""></v-avatar>{{ curSelectBoisson.nom }} </v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout px-3>
                  <v-flex px-2>
                    <v-text-field auto-grow type="number" v-model="boissonsitems.find(item => item.id === selectboisson).qte" label="Quantité" suffix="cl" prepend-icon="local_drink"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout px-3>
                  <v-flex px-2>
                    <v-text-field auto-grow type="number" v-model="boissonsitems.find(item => item.id === selectboisson).alc" label="Taux d'Alcool" suffix="°" prepend-icon="opacity"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-card-actions>
                  <v-btn flat @click="addConso(curSelectBoisson.nom, curSelectBoisson.qte, curSelectBoisson.alc)" color="orange">Ajouter</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout ma-2>
            <v-flex>
              <v-card>
                <v-toolbar color="primary" dark>
                  <v-toolbar-title> <v-chip color="blue darken-3" text-color="white">3</v-chip> Consommations</v-toolbar-title>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout ma-2>
            <v-data-table
              :items="consoSorted"
              :headers="consoheaders"
              hide-actions
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.heure }}</td>
                <td>{{ props.item.nom }}</td>
                <td>{{ props.item.qte }}&nbsp;cl</td>
                <td>{{ props.item.alc }}&nbsp;°</td>
                <td><v-btn @click="delBoisson(props.item.nom, props.item.datetime, props.item.qte, props.item.alc)" fab dark small color="red"><v-icon>delete</v-icon></v-btn></td>
              </template>
            </v-data-table>
          </v-layout>
          
          <v-btn large dark color="green" @click="subForm()"><v-icon>opacity</v-icon>&nbsp;&nbsp; Calculer </v-btn>

      </v-container>

      <v-container v-if="step3" class="topel">

        <v-layout ma-3 >
          <v-flex class="title">
            <v-chip color="blue darken-3" text-color="white">1</v-chip> Estimation de votre taux en ce moment ({{ timefrnow }}) :
          </v-flex>
        </v-layout>

        <v-layout ma-3>
          <v-flex xs12 sm6 md4 mx-auto>
            <v-alert outline v-if="resultinfos.taux > 0.5" type="error" :value="true" class="title">
              {{ resultinfos.taux }} g/l
            </v-alert>
            <v-alert outline v-else type="success" :value="true" class="title">
              {{ resultinfos.taux }} g/l
            </v-alert>
            <v-alert outline v-if="resultinfos.taux > 0.5" type="error" :value="true">
              Votre taux est actuellement estimé supérieur à 0,5&nbsp;g/l. Vous pourriez être sous le seuil de 0,5&nbsp;g/l vers {{ safedatefr }}
            </v-alert>
          </v-flex>
        </v-layout>

         <v-layout my-4>
          <v-flex subheading class="text-xs-center">
            Votre <strong>pic</strong> d'alcoolémie est estimé à : <strong :class="resultinfos.maxcolor">{{ resultinfos.maxtaux }}&nbsp;g/l</strong> à <strong>{{ dateTimeFr(resultinfos.maxtime) }}</strong>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout ma-3 >
          <v-flex class="title">
            <v-chip color="blue darken-3" text-color="white">2</v-chip> Evolution dans le temps
          </v-flex>
        </v-layout>

        <v-layout mx-3>
          <v-flex xs12>
            Faites glisser le curseur pour voir l'évolution du taux d'alcool dans le temps
             <v-slider :label="chartlabels[slider.val].toString()" :min="0" :max="(chartdatasets[0].data.length - 1)" v-model="slider.val" :color="slidcolor"></v-slider>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 sm8 md6 mx-auto>
            <v-alert outline :type="slidtype" :value="true" class="title">
              <span class="subheading">Estimation du taux sanguin à {{ slidheure }} :</span><br />
              {{ slidtaux}} g/l
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 sm8 md6 mx-auto>
            <v-alert outline :type="slidtype" :value="true" class="title">
              <span class="subheading">Equivalence en taux par litre d'air alvéolaire expiré :</span><br />
              {{ slidtauxaae }} mg/l AAE
            </v-alert>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12>

          </v-flex>
        </v-layout>
           
        <p></p>
        <v-divider></v-divider>

        <v-layout ma-3 >
          <v-flex class="title">
            <v-chip color="blue darken-3" text-color="white">3</v-chip> Graphique
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12>
            <chartjs-line 
            :labels="chartlabels" 
            :datasets="chartdatasets"
            :option="myoption"
            :bind="true"
            ></chartjs-line>
          </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 class="text-xs-center">
              <v-btn large dark color="primary" @click="retour()"><v-icon>chevron_left</v-icon> Retour</v-btn>
            </v-flex>
          </v-layout>

      </v-container>

      <v-snackbar
        :timeout=6000
        color="error"
        :vertical=true
        v-model="p1snack"
      >
        {{ snackText }}
        <v-btn dark flat @click.native="p1snack = false">Fermer</v-btn>
      </v-snackbar>

      <v-container style="padding-top:0px;">
        <v-layout px-3>
            <v-flex xs12>
              <v-alert outline color="info" icon="info" :value="true" style="line-height:1em;">
                <span style="font-size:.8em;" class="grey--text text--darken-1">Nous avons développé l'outil le plus précis et le plus fiable possible. Toutefois, le taux d'intoxication alcoolique dépend de multiples facteurs qui ne peuvent pas tous être intégrés dans un algorithme de calcul. Notre éthylotest virtuel ne peut donc en aucun cas être utilisé pour garantir l'aptitude à la conduite.</span>
              </v-alert>
            </v-flex>
          </v-layout>
      </v-container>

    </v-app>
  </div>
</template>

<script>
import moment from 'moment-mini'
moment.locale('fr')
export default {
  name: 'app',
  data () {
    return {
      snackText: "",
      p1snack: false,
      selectboisson: 1,
      allowedTimes: {
        hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
        minutes: [0,10,20,30,40,50]
      },
      date: moment().format('YYYY-MM-DD'),
      time: moment(this.date).add(-2,'hours').format('H:00'),
      dateFr: moment().format('DD/MM/YYYY'),
      menu: null,
      menu2: false,
      step1: true,
      step2: true,
      step3: false,
      sexe: null,
      repas: null,
      poids: null,
      pilscont: 25,
      specialecont: 25,
      vincont: 12,
      digestifcont: 5,
      tauxspeciale: 7,
      tauxdigestif: 40,
      tauxperso: 40,
      persocont: 10,
      champagnecont: 12,
      chartdata: null, 
      chartlabels: [0],
      slider: {
        val: 1
      },
      myoption: {
        responsive:true,
        maintainAspectRatio:true,
        borderColor: "rgba(255,255,255,1)",
        backgroundColor: "rgba(0,0,0,.5)",
        annotation: {
            annotations: [{
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                value: '0.5',
                borderColor: 'red',
                borderWidth: 2,
                borderDash: [2,2]
            }]
        }
      },
      chartdatasets:[
        {
          label: "Alcoolémie",
          fill: true,
          lineTension: 0.1,
          backgroundColor: "rgba(153,115,115,0.2)",
          borderColor: "rgba(0,0,0,.3)",
          borderCapStyle: 'round',
          borderDash: [],
          borderDashOffset: 1,
          borderJoinStyle: 'miter',
          pointBackgroundColor: "rgba(255,255,255,1)",
          pointBorderWidth: 3,
          pointHoverRadius: 9,
          pointHoverBackgroundColor: "rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: [0],
          pointBorderColor: [],
          spanGaps: true
        }
      ],
      resultinfos: [
        {'safe': null} 
      ],
      boissonsitems: [
        { 'id': 1, 'nom': 'Bière Pils', 'avatar': '/static/pils25cl.jpeg', 'qte': 25, 'alc': 5 },
        { 'id': 2, 'nom': 'Bière Spéciale', 'avatar':'/static/speciale.jpg', 'qte': 33, 'alc': 7 },
        { 'id': 3, 'nom': 'Vin', 'avatar':'/static/vin.jpg', 'qte': 12, 'alc': 12 },
        { 'id': 4, 'nom': 'Champagne', 'avatar': '/static/champagne.jpg', 'qte': 12, 'alc': 12 },
        { 'id': 5, 'nom': 'Digestif', 'avatar':'/static/digestif.jpg', 'qte': 4, 'alc': 40 },
        { 'id': 6, 'nom': 'Personnalisé', 'avatar':'/static/perso.jpg', 'qte': 10, 'alc': 40 },
      ],
      consoheaders: [
        { text:'Heure', sortable:false, align: 'center', value:'heure' },
        { text:'Nom', sortable:false, align:'center', value:'nom' },
        { text:'Qté', sortable:false, align:'center', value:'qte' },
        { text:'Alc.', sortable:false, align:'center', value:'alc' },
        { text:'Supp.', sortable:false, align: 'center' }
      ],
      conso: []
      
    }
  },
  methods: {
    dateTimeFr: function($dt, $outfmt = 'HH:mm [le] DD/MM/YYYY', $fmt = 'YYYY-MM-DD HH:mm') {
      return moment($dt, $fmt).format($outfmt)
    },
    scrollToTop () {
      document.getElementById('topel').scrollIntoView();
    },
    retour: function() {
      this.step3 = false
      this.step2 = true
      this.step1 = true
      this.scrollToTop()
    },
    subForm: function () {
      this.p1snack = false
      if (!this.poids) {
        this.snackText = "Vous devez indiquer votre poids."
        this.p1snack = true
      } else if (!this.sexe) {
        this.snackText = "Vous devez indiquer votre sexe."
        this.p1snack = true
      } else if (!this.repas) {
        this.snackText = "Vous devez indiquer si vous avez consommé un repas."
        this.p1snack = true
      } else if (this.consoSorted.length == 0) {
        this.snackText = "Veuillez indiquer vos consommations."
        this.p1snack = true
      } else {
        this.getAlc()
        this.step1 = false
        this.step2 = false
        this.step3 = true
        this.scrollToTop()
      }
    },
    delBoisson: function ($nom, $heure, $qte, $alc) {
      let toDel = this.conso.findIndex(item => item.datetime === $heure, item => item.nom === $nom, item => item.qte === $qte, item => item.alc === $alc)
      this.conso.splice(toDel,1)
    },
    addConso: function($nom, $qte, $alc) {
      let curconso = {}
      let consodt =  moment(this.date + this.time, 'YYYY-MM-DD HH:mm')
      curconso['heure'] = consodt.format('DD/MM à HH:mm')
      curconso['nom'] = $nom
      curconso['qte'] = $qte
      curconso['alc'] = $alc
      curconso['datetime'] = consodt.format('YYYY-MM-DD HH:mm')
      curconso['alcpur'] = ((($qte * 10) * $alc) / 100)
      this.conso.push(curconso)
      let dtnext = consodt.add(30, 'minutes')
      this.date = moment(dtnext).format('YYYY-MM-DD')
      this.time = moment(dtnext).format('HH:mm')
      // this.getAlc()
    },
    getAlc: function() {
      this.axios.post('https://jm-a.be/apiv2/simalcool', JSON.stringify(this.simdata))
      .then(response => {
        // this.chartdata = response.data.data
        this.chartdatasets[0].pointBorderColor = response.data.color
        // this.chartdatasets[0].pointBackgroundColor = response.data.color
        this.chartdatasets[0].data = response.data.data
        this.chartlabels = response.data.labels
        this.resultinfos = response.data.infos
        this.scrollToTop()
      })
    },
    formatDate: function (date) {
      if (!date) return null
      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    parseDate: function (date) {
      if (!date) { return null }
      return moment(date,'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    checkS1: function () {
      if (this.poids && this.sexe && this.repas) { this.step2 = true }
    }
  },
  computed: {
    slidcolor: function () {
      // let color = (this.chartdatasets[0].data[this.slider.val] > 0.5) ? 'red' : 'green'
      let color=''
      if (this.chartdatasets[0].data[this.slider.val] < 0.45) { color = 'green' }
      else if (this.chartdatasets[0].data[this.slider.val] < 0.5) { color = 'orange' }
      else { color = 'red' }
      return color
    },
    slidtype: function () {
      // let color = (this.chartdatasets[0].data[this.slider.val] > 0.5) ? 'error' : 'success'
      let color=''
      if (this.chartdatasets[0].data[this.slider.val] < 0.45) { color = 'success' }
      else if (this.chartdatasets[0].data[this.slider.val] < 0.5) { color = 'warning' }
      else { color = 'error' }
      return color
    },
    slidheure: function () {
      return this.chartlabels[this.slider.val]
    },
    slidtaux: function () {
      return this.chartdatasets[0].data[this.slider.val]
    },
    slidtauxaae: function() {
      let tauxsang = this.slidtaux
      let tauxaae = this.slidtaux / 2.286
      return tauxaae.toFixed(3)
    },
    timefrnow: function() {
      return moment().format('HH:mm');
    },
    safedatefr: function() {
      return moment(this.resultinfos.safetime, 'YYYY-MM-DD HH:mm').format('HH:mm (DD/MM/YYYY)')
    },
    simdata: function () {
      let fdata = {}
      fdata.options = { 'modechartjs':true }
      fdata.infos = { 'poids': this.poids, 'sexe': this.sexe, 'repas':this.repas }
      fdata.conso = this.consoSorted
      return fdata
    },
    consoSorted: function () {
      return this.conso.sort((a,b) => a.datetime > b.datetime)
    },
    curSelectBoisson: function () {
      return this.boissonsitems.find(item => item.id === this.selectboisson)
    }
  },
  created () {

  },
  mounted () {

  }

}
</script>

<style>
#app {
  font-family: 'Roboto','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue